import { useLayoutEffect } from 'react'
import { SidebarProvider } from '../context/sidebar'
import { useSidebar } from '../context/sidebar'
import { AgentsProvider } from '../context/agents'
import { Outlet, useLocation } from 'react-router'
import AppHeader from './AppHeader'
import Backdrop from './Backdrop'
import AppSidebar from './AppSidebar'
import { Toaster } from '@/design-system/molecules/Toast'
import { ServerWakeGuard } from '../components/auth/ServerWakeGuard'

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar()
  const location = useLocation()

  // Verificar se estamos na rota de chat (layout full screen)
  const isChatRoute = location.pathname.includes('/chat')

  // Evita que scroll/y do dashboard seja herdado na entrada do chat
  useLayoutEffect(() => {
    if (!isChatRoute) return

    const html = document.documentElement
    const body = document.body

    const prevHtmlOverflow = html.style.overflow
    const prevBodyOverflow = body.style.overflow

    // Lock scroll and pin root to avoid inherited offsets
    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      html.scrollTop = 0
      body.scrollTop = 0
    }

    resetScroll()
    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'

    return () => {
      html.style.overflow = prevHtmlOverflow
      body.style.overflow = prevBodyOverflow
    }
  }, [isChatRoute])

  return (
    <div
      className={
        isChatRoute
          ? 'h-screen xl:flex overflow-hidden'
          : 'min-h-screen xl:flex'
      }
    >
      <div>
        <AppSidebar />
        <Backdrop />
      </div>
      <div
        className={`flex-1 min-h-0 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? 'lg:ml-[290px]' : 'lg:ml-[90px]'
        } ${isMobileOpen ? 'ml-0' : ''} ${isChatRoute ? 'flex flex-col h-full overflow-hidden' : ''}`}
      >
        <AppHeader />
        <div
          className={
            isChatRoute
              ? 'flex-1 flex flex-col lg:flex-row relative min-h-0 overflow-hidden'
              : 'p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6'
          }
          style={isChatRoute ? { height: 'calc(100vh - 77px)' } : undefined}
        >
          {isChatRoute ? (
            <div className="flex-1 min-h-0 flex flex-col h-full">
              <Outlet />
            </div>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  )
}

const AppLayout: React.FC = () => {
  return (
    <AgentsProvider>
      <SidebarProvider>
        <LayoutContent />
        <Toaster position="top-right" richColors closeButton />
        {/* O idle-check desliga o servidor depois de 1 h sem uso: quem está
            com o app aberto precisa do mesmo popup de "ligar o servidor"
            que a tela de login já tinha. */}
        <ServerWakeGuard />
      </SidebarProvider>
    </AgentsProvider>
  )
}

export default AppLayout
